import { useLang } from "@/context/LangContext";
import { PORTRAIT } from "@/data/photos";

const About = () => {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-paper-alt border-y border-hairline"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="relative aspect-[4/5] max-w-md lg:max-w-none overflow-hidden bg-ink">
            <img
              src={PORTRAIT.src}
              alt={PORTRAIT.alt}
              className="w-full h-full object-cover grayscale contrast-110"
              loading="lazy"
              data-testid="portrait-image"
            />
          </div>
          <p className="font-mono text-[0.7rem] tracking-[0.3em] uppercase text-muted mt-4">
            Autoritratto · Studio, Italia
          </p>
        </div>

        <div className="lg:col-span-7">
          <p className="overline mb-4">03 — {t.about.title}</p>
          <h2 className="display-xl text-[2.6rem] sm:text-[3.8rem] lg:text-[4.8rem] mb-6 leading-[0.95]">
            Simone <span className="italic font-normal">Orfanò</span>
          </h2>
          <p className="font-mono text-[0.7rem] tracking-[0.35em] uppercase text-muted mb-8">
            aka Simon O. — The Barber Photographer
          </p>
          <div className="space-y-6 font-display text-lg sm:text-xl leading-relaxed text-ink-soft max-w-2xl" data-testid="about-body">
            {t.about.body.map((paragraph, i) => (
              <p key={paragraph.slice(0, 24)} className={i === 0 ? "first-letter:font-display first-letter:text-6xl first-letter:font-black first-letter:float-left first-letter:leading-none first-letter:mr-3 first-letter:mt-1" : ""}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
